// @core/api/endpoints/payment/delete_payment_route.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/payment';

/**
 * Delete payment route
 * Permanently deletes the specified payment route.
 */
export async function DeletePaymentRoute(
  id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-routes/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
